

import Blank from '@/views/Blank.vue'

export function menuToRoutes(menuTree = []) {
  const routes = []

  const convert = (list) => {
    const res = []
    list.forEach(menu => {
      const route = {
        path: menu.path,
        name: menu.name || menu.id,
        meta: menu.meta || {}
      }

      // 解析组件
      const comp = menu.component || ''
      if (comp === 'layout/Layout' || comp.toLowerCase().includes('layout')) {
        // 使用轻量容器承载 children，避免重复头部
        route.component = Blank
      } else if (typeof comp === 'string' && (comp.startsWith('/') || comp.indexOf('/') > -1)) {
        let file = comp
        if (!/\.vue$/i.test(file)) file = `${file}.vue`
        route.component = () => import(`@/views${file}`)
      } else if (menu.children && menu.children.length > 0) {
        // 作为分组节点
        route.component = Blank
      }

      // 子集
      if (menu.children && menu.children.length > 0) {
        route.children = convert(menu.children)
        // 默认重定向到第一个子路由
        route.redirect = { name: route.children[0].name }
      } else if (!route.component) {
        // 叶子节点且未显式指定 component，按 path 推导
        try {
          const lastSlash = (menu.path || '').lastIndexOf('/')
          const dir = (menu.path || '').substring(0, lastSlash)
          const name = (menu.path || '').substring(lastSlash + 1)
          
          // 智能文件名转换：kebab-case 转 PascalCase
          const pascalName = name.split('-').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join('')
          
          // 根据路径智能选择文件名
          let fileName
          if (name.includes('-')) {
            // 如果包含连字符，使用 PascalCase（如 data-definition -> DataDefinition）
            fileName = pascalName
          } else {
            // 如果不包含连字符，首字母大写（如 definition -> Definition）
            fileName = name.charAt(0).toUpperCase() + name.slice(1)
          }
          
          const filePath = `${dir}/${fileName}.vue`
          route.component = () => import(`@/views${filePath}`)
        } catch (e) {
        }
      }

      res.push(route)
    })
    return res
  }

  routes.push(...convert(menuTree))
  return routes
}


